import React from 'react'

import { arrayOf, bool, shape, string } from 'prop-types'

function SelectField({
  id,
  name,
  label,
  placeholder,
  options,
  required = false,
  isDark = false,
  className = '',
}) {
  return (
    <div className={`discover-field ${className}`}>
      <label htmlFor={id} className={`discover-field__label${isDark ? ' discover-field__label--dark' : ''}`}>
        {label}
      </label>
      <select
        id={id}
        name={name}
        className="discover-field__control discover-field__control--select"
        defaultValue=""
        required={required}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  )
}

SelectField.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  label: string.isRequired,
  placeholder: string.isRequired,
  options: arrayOf(shape({ value: string.isRequired, label: string.isRequired })).isRequired,
  required: bool,
  isDark: bool,
  className: string,
}

export default SelectField
